import { useNavigate, Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import EnrollPage from './pages/Enroll.js';
import EnrollM1Page from './pages/EnrollM1.js';
import EnrollM1_internalPage from './pages/EnrollM1_internal.js';
import FailMessagePage from './pages/FailMessage.js';
import StampPage from './pages/Stamp.js';
import PaymentResultPage from './pages/PaymentResult.js';
import PageNotFoundPage from './pages/PageNotFound.js';
import EnrollMultiStep1Page from './pages/multi-pickup/EnrollMultiStep1.js';
import EnrollMultiStep2Page from './pages/multi-pickup/EnrollMultiStep2.js';
import NPEnrollM1Page from './pages/non-payment-registration/night-promo-945/NPEnrollM1.js';
import NPStampPage from './pages/non-payment-registration/night-promo-945/NPStamp.js';
import NPSuccessPage from './pages/non-payment-registration/night-promo-945/NPSuccess.js';
import CouponStampPage from  './pages/non-payment-registration/night-promo-945/CouponStamp.js';
import VersionPage from  './pages/Version.js';
import Poc from  './pages/Poc.js';
import PocImage from  './pages/PocImage.js';
import PocImage2 from  './pages/PocImage2.js';
import EventImagePage from  './pages/EventImage.js';

function App() {
  const navigate = useNavigate();
  const PUBLIC_URL =process.env.PUBLIC_URL;
  const location = useLocation();
  const eventName = location.pathname.split('/')[2];
  const [searchParams, setSearchParams] = useSearchParams();  
  let channel = "";
  let code = "";
  let invoiceno = "";
  let hash = "";
  let errcode = "";
  let isinternal = false;
  let locid = "";
  let isdebugmode = false;
  let geocode = "";
  let mobile = "";
  let isImageOnly = false;
  let isSelfServe = true;
  let isNotSelfServe = false;

  window.name = eventName;

  if(searchParams.get("src") === null){
    channel = "others";
  } else {
    channel = searchParams.get("src");
  }
  if(searchParams.get("code") != null){
    code = searchParams.get("code");
  }
  if(searchParams.get("invoiceno") != null){
    invoiceno = searchParams.get("invoiceno");
  }
  if(searchParams.get("hash") != null){
    hash = searchParams.get("hash");
  }
  if(searchParams.get("errcode") != null){
    errcode = searchParams.get("errcode");
  }  
  if(searchParams.get("isinternal") != null){
    isinternal = searchParams.get("isinternal");
  }  
  if(searchParams.get("locid") != null){
    locid = searchParams.get("locid");
  }
  if(searchParams.get("geocode") != null){
    geocode = searchParams.get("geocode");
  }
  if(searchParams.get("mobile") != null){
    mobile = searchParams.get("mobile");
  }
  if(searchParams.get("isdebugmode") != null && searchParams.get("isdebugmode") === "hkjebn"){
    isdebugmode = true;
  }
  if(location.pathname.split('/')[2]=="event-image")
  {
    isImageOnly = true;
  }
  
  return (
    <>    
    <div>
      {/* <button onClick={() => navigate(-1)}>go back</button> */}
    </div>
    {isImageOnly ? (
      <div >
        <Routes>
          <Route exact path="/:PUBLIC_URL/event-image" element={<EventImagePage/>}/>
        </Routes>
      
    </div>
    ) : 
    (
      <div className="main-body row">
        <div className="col-md-2 col-lg-3 col-xl-3 col-xxl-4"></div>
        <div className="col-md-8 col-lg-6 col-xl-6 col-xxl-4 main-cell">
          <Routes>
            <Route exact path="/:PUBLIC_URL/" element={<PageNotFoundPage/>}/>

            {/* For night promo 945 */}
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/npenrollm1" element={<NPEnrollM1Page channel={channel} isdebugmode={isdebugmode} isExternalAccess="true"/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/npstamp" element={<NPStampPage code={code} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/npsuccess" element={<NPSuccessPage isdebugmode={isdebugmode} invoiceno={invoiceno} hash={hash}/>}/>

            {/* For TST Opening */}
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/npenrollM1_vippreRegistration" element={<NPEnrollM1Page channel={channel} isdebugmode={isdebugmode} isExternalAccess="false"/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/npenrollM1_onsiteRegisteration" element={<NPEnrollM1Page channel={channel} isdebugmode={isdebugmode} isExternalAccess="false"/>}/>

            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/couponstamp" element={<CouponStampPage isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/version" element={<VersionPage/>}/>
            <Route exact path="/:PUBLIC_URL/poc" element={<Poc/>}/>
            <Route exact path="/:PUBLIC_URL/poc-image" element={<PocImage/>}/>
            <Route exact path="/:PUBLIC_URL/poc-image2" element={<PocImage2/>}/>


            {/* For payment event */}
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/multi/enrollm1step1" element={<EnrollMultiStep1Page channel={channel} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/multi/enrollm1step2" element={<EnrollMultiStep2Page channel={channel} geocode={geocode} mobile={mobile} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/enrollm1" element={<EnrollM1Page channel={channel} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/enroll" element={<EnrollPage channel={channel} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/enrollm1" element={<EnrollM1Page channel={channel} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/enrollm1_internal" element={<EnrollM1_internalPage channel={channel} isdebugmode={isdebugmode} isSelfServe={isNotSelfServe} />}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/enrollM1_selfserve" element={<EnrollM1_internalPage channel={channel} isdebugmode={isdebugmode} isSelfServe={isSelfServe} />}/>

            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/stamp" element={<StampPage code={code} isdebugmode={isdebugmode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/paymentresult" element={<PaymentResultPage isdebugmode={isdebugmode} invoiceno={invoiceno} hash={hash}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota" element={<FailMessagePage isFullQuota="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota-carnival-0914" element={<FailMessagePage isFullQuotaCarnival0914="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota-carnival-0915" element={<FailMessagePage isFullQuotaCarnival0915="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota-2025062122_carnival" element={<FailMessagePage isFullQuotaCarnival2025="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota-tasting_certificate" element={<FailMessagePage isFullQuotaTastingCertificate="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-full-quota-2026032829_TSTopening" element={<FailMessagePage isFullQuotaTSTopening="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-internal-event-20260910_crab" element={<FailMessagePage isInternalOnly="true" />}/>

            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-cct" element={<FailMessagePage hasCurrentCycleTx="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-invalid-multi-pickup" element={<FailMessagePage isNotMultiBatch="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-duplicate" element={<FailMessagePage isDuplicate="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-wrong-format" element={<FailMessagePage isWrongFormat="true" isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-reg-error" element={<FailMessagePage isRegError="true" isInternal={isinternal} locid={locid} errcode={errcode}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/fail-error" element={<FailMessagePage isInternal={isinternal} locid={locid}/>}/>
            <Route exact path="/:PUBLIC_URL/:EVENT_NAME/event-not-effective" element={<FailMessagePage isEventNotEffective="true"/>}/>
            <Route exact path="/:PUBLIC_URL/fail-wrong-url" element={<FailMessagePage isWrongUrl="true"/>}/>
            <Route exact path="/:PUBLIC_URL/fail-wrong-expired-stamp" element={<FailMessagePage isExpiredStamp="true"/>}/>
            <Route path="*" element={<FailMessagePage isWrongUrl="true"/>}/>
          </Routes>
        </div>
        <div className="col-md-2 col-lg-3 col-xl-3 col-xxl-4"></div>
      </div>
    )}
   </>
  );
}

export default App;
